<div class="flex flex-row gap-2">
  <p-select [options]="viewOptions" [ngModel]="finalView()" (onChange)="onModeChange($event)"></p-select>
  <input pInputText [ngModel]="search()" (ngModelChange)="onSearchChange($event)" placeholder="Search"/>
  <p-button (onClick)="openById()" icon="pi pi-user" label="Open by ID"></p-button>
</div>

<div class="flex flex-row gap-2 mt-2 mb-4" >
  <p-button (onClick)="downloadCsv()" icon="pi pi-file" label="Export CSV"></p-button>
  <p-button (onClick)="copyToApply()" [disabled]="selectedUsers().length === 0" icon="pi pi-user" label="Auto-register"></p-button>
  <p-button (onClick)="reconnectFirstTwentyHouseholds()"
            [disabled]="bulkReconnectLoading()"
            [loading]="bulkReconnectLoading()"
            icon="pi pi-refresh"
            label="Reconnect 20 households">
  </p-button>
  @if (bulkReconnectMessage()) {
    <span class="text-sm text-surface-500">{{ bulkReconnectMessage() }}</span>
  }
</div>

<p-table [value]="sortedUsers()" [(selection)]="selectedUsers">
  <ng-template pTemplate="header">
    <tr>
      @if (finalView() === 'to-register') {
        <td></td>
      }
      <th>Id</th>
      <th>Created at</th>
      <th>Name</th>
      <th>Email</th>
      <th>Assistance</th>
      <th>Last seen</th>
      <th>Payment</th>
      <th>Status</th>
      <th>NYC Profile</th>
      <th>NYC Sync</th>
      <th>NYC State</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user [cTypedTableRow]="sortedUsers()">
    <tr>
      @if (finalView() === 'to-register') {
        <td>
          <p-tableCheckbox [value]="user"/>
        </td>
      }
      <td>
        <app-new-window-link [id]="user.id"/>
      </td>
      <td>{{ user.createdAt | date:'M/d/yy, h:mm a' }}</td>
      <td>{{ user.firstName }} {{ user.lastName }}</td>
      <td>{{ user.email }}</td>
      <td>{{user.rentalAssistance}}</td>
      <td>{{ user.lastSeen | date:'M/d/yy, h:mm a' }}</td>
      <td>
        <p-tag>{{ user.paymentStatus }}</p-tag>
      </td>
      <td>
        <p-tag>{{ user.status }}</p-tag>
      </td>
      <td>
        <p-tag>{{ user.nycProfileStatus }}</p-tag>
      </td>
      <td>
        @if (user.nycSyncStatus) {
          <p-tag>{{ user.nycSyncStatus }}</p-tag>
        }
      </td>
      <td>@if (user.isNycBroken) {
        <p-tag severity="danger">NYC BROKEN</p-tag>
      } @else {
        <p-tag>NYC Correct</p-tag>
      }</td>
      <td>
        @if (user.ignore) {
          <p-tag severity="danger">IGNORED</p-tag>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
